import { useContext } from 'react'
import { TourGuideContext } from './tourGuideContextCore'

export const useTourGuide = () => {
  const context = useContext(TourGuideContext)
  if (!context) throw new Error('useTourGuide must be used within TourGuideProvider')
  return context
}
